import { render, staticRenderFns } from "./ASelecionar-modulo.vue?vue&type=template&id=10d67940"
import script from "./ASelecionar-modulo.vue?vue&type=script&lang=js"
export * from "./ASelecionar-modulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports